import { defaultLocale, isLocale, type Locale } from "./config"

/**
 * Parse Accept-Language and return the best matching supported locale.
 */
export function resolveLocaleFromAcceptLanguage(
  acceptLanguage: string | null | undefined
): Locale | null {
  if (!acceptLanguage) {
    return null
  }

  const preferences = acceptLanguage
    .split(",")
    .map((part) => {
      const [tag, qPart] = part.trim().split(";q=")
      const q = qPart ? Number.parseFloat(qPart) : 1
      return { tag: tag?.toLowerCase() ?? "", q: Number.isNaN(q) ? 0 : q }
    })
    .sort((a, b) => b.q - a.q)

  for (const { tag } of preferences) {
    if (isLocale(tag)) {
      return tag
    }
    const primary = tag.split("-")[0]
    if (primary && isLocale(primary)) {
      return primary
    }
  }

  return null
}

export function resolveLocale(
  cookieValue: string | null | undefined,
  acceptLanguage: string | null | undefined
): Locale {
  if (cookieValue && isLocale(cookieValue)) {
    return cookieValue
  }

  return resolveLocaleFromAcceptLanguage(acceptLanguage) ?? defaultLocale
}
